<fa-layers [fixedWidth]="true" [ngClass]="ConversationStatus.styleClass">
   <fa-icon class="conversation-type" [icon]="ConversationType.icon"></fa-icon>
   <fa-icon
      class="conversation-status"
      *ngIf="ConversationStatus.icon"
      [icon]="ConversationStatus.icon"
      [transform]="ConversationStatus.iconTransformCommand"
   ></fa-icon>
   <fa-icon
      class="ici-type"
      *ngFor="let iciVisualization of conversationIciVisualization"
      [ngClass]="iciVisualization.styleClass"
      [icon]="iciVisualization.icon"
      [transform]="iciVisualization.iconTransformCommand"
   >
   </fa-icon>
</fa-layers>
